import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

const employeeId = (userId: number | null, filteredEmployees: Employee[]) => {
  if (!userId) return null

  const user = users.get(userId)
  const employee =
    user && !user.isNew
      ? employees.find({
          access_id: user.attributes.id,
        })
      : undefined

  if (!employee?.id) return null

  return filteredEmployees.some((e) => e.id === employee.id) ? employee?.id : null
}

export default employeeId
